import {  useUserContext } from 'features/users';
import { LoginUserRolePermission, PermissionFlags } from "types";

export const HasPermission = (
  menuKey: string,
  action: keyof PermissionFlags  
): boolean => {

  const { user } = useUserContext();

  if(user===undefined || user?.rolePermission===undefined && Array.isArray(user?.rolePermission))
    return false ;
  
 const rolePermission: LoginUserRolePermission[] = Array.isArray(user?.rolePermission)
  ? user.rolePermission
  : [];

  const item = rolePermission.find(p => p.menuKey === menuKey);
  
return item?.permissions?.[action] ?? false;
};